module.exports = __webpack_public_path__ + "img/suitcase.f2f9e2dc.png";